module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am72-bd97d0422c0724f9d2f979306de1b833.jpg";